function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M665.22 26.706l565.554 980.189c20.536 35.607-5.142 80.105-46.231 80.105H53.45c-41.088 0-66.75-44.498-46.23-80.105l565.554-980.19c20.552-35.607 71.893-35.607 92.445 0",
  id: "green-triangle_svg__a"
}));

var _ref2 = /*#__PURE__*/React.createElement("use", {
  fill: "#0AC700",
  fillRule: "nonzero",
  xlinkHref: "#green-triangle_svg__a",
  transform: "rotate(-3 -17072.993 11435.696)"
});

function SvgGreenTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 669 178"
  }, props), _ref, _ref2);
}

export default SvgGreenTriangle;